var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { View as ContentCollectionHorizontal, } from "contentCollection/horizontal";
import { BoxCover } from "core/components";
import { SliderWrapper } from "core/components/Slider";
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { mq } from "core/styles/snippets";
import { Tracking } from "core/tracking";
import { Env, config } from "core/utils";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getTrackingData } from "../BoxCover/Details";
import { HoverCard } from "../HoverCard";
import { Modal } from "../Modal";
export var BoxCoverCollection = function (props) {
    var items = props.items, componentId = props.componentId, listName = props.listName, trackingEnabled = props.trackingEnabled, title = props.title, className = props.className, trackingData = props.trackingData;
    var _a = useState(null), isModalOpen = _a[0], setModalOpen = _a[1];
    var _b = useState(null), isShowing = _b[0], setIsShowing = _b[1];
    var _c = useState(), hoverPosition = _c[0], setHoverPostion = _c[1];
    var _d = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _d.ref, enteredViewport = _d.enteredViewport;
    var timer;
    var mouseEnter = function (data, boxCoverRef) {
        timer = setTimeout(function () {
            var _a, _b;
            setHoverPostion({
                left: Number((_a = boxCoverRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) -
                    parseInt(window.getComputedStyle(ref.current).paddingLeft, 10) -
                    parseInt(window.getComputedStyle(ref.current).marginLeft, 10),
                top: (_b = boxCoverRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().y,
            });
            setIsShowing(data);
        }, 300);
    };
    var onKeyEnter = function (event, data, ref) {
        if (ref.current) {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault(); // Prevent scrolling when pressing space
                setHoverPostion({
                    left: Number(event.currentTarget.getBoundingClientRect().left) -
                        parseInt(window.getComputedStyle(ref.current).paddingLeft, 10) -
                        parseInt(window.getComputedStyle(ref.current).marginLeft, 10),
                    top: event.currentTarget.getBoundingClientRect().y,
                });
                setIsShowing(data);
            }
        }
    };
    var mouseLeave = function () {
        clearTimeout(timer);
    };
    useEffect(function () {
        if (trackingEnabled && enteredViewport) {
            Tracking.trackCollection(listName, items);
        }
    }, [trackingEnabled, enteredViewport]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledContentCollectionHorizontal, { componentId: componentId, title: title, setIsShowing: setIsShowing, isShowing: isShowing, hoverPosition: hoverPosition, className: className, ref: ref }, function () {
            return items.map(function (item, index) { return (React.createElement(BoxCover.View, { onClick: function () { return Env.isTouch && setModalOpen(item); }, url: !Env.isTouch && item.slug ? item.slug : undefined, details: item, mouseEnter: mouseEnter, mouseLeave: mouseLeave, onKeyEnter: onKeyEnter, trackingData: getTrackingData(item, listName, index + 1), key: item.uuid })); });
        }),
        Env.isTouch && isModalOpen && (React.createElement(Modal, { isModalOpen: isModalOpen, setModalOpen: setModalOpen },
            React.createElement(HoverCard, { laneName: listName, item: isModalOpen })))));
};
var StyledContentCollectionHorizontal = styled(ContentCollectionHorizontal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    grid-auto-columns: calc(33.333333% - 0.33333333rem);\n\n    ", " {\n      grid-column-gap: 1rem;\n      grid-auto-columns: calc(16.66666667% - 0.83333333rem);\n    }\n\n    ", " {\n      grid-column-gap: 1.5rem;\n      grid-auto-columns: calc(12.5% - 1.3125rem);\n    }\n\n    ", " {\n      grid-auto-columns: calc(12.5% - 1.3125rem);\n    }\n  }\n"], ["\n  ", " {\n    grid-auto-columns: calc(33.333333% - 0.33333333rem);\n\n    ", " {\n      grid-column-gap: 1rem;\n      grid-auto-columns: calc(16.66666667% - 0.83333333rem);\n    }\n\n    ", " {\n      grid-column-gap: 1.5rem;\n      grid-auto-columns: calc(12.5% - 1.3125rem);\n    }\n\n    ", " {\n      grid-auto-columns: calc(12.5% - 1.3125rem);\n    }\n  }\n"])), SliderWrapper, mq.minWidth("48rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
